module.exports = __webpack_public_path__ + "img/IT0000643851644.8d49ed74.png";